<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="material-table-widget dashboard_top_bar">
              <button class="btn btn-default btn-new" id="show-modal" @click="ContactModal = true"><i class="fa fa-user"></i>&nbsp;新增聯絡人</button>

              <div role="group" class="btn-group pull-right mt-0">
              	<button @click="order_type = 'new'" v-bind:class="{'active btn-success' : order_type == 'new'}" class="btn btn-default"><i class="fas fa-sort-amount-down"></i> 新到舊({{orderdObjects('new').length}})</button> 
              	<button @click="order_type = 'old'" v-bind:class="{'active btn-success' : order_type == 'old'}" class="btn btn-default"><i class="fas fa-sort-amount-up"></i> 舊到新({{orderdObjects('old').length}})</button>
              	<button @click="order_type = 'revenue'" v-bind:class="{'active btn-success' : order_type == 'revenue'}" class="btn btn-default"><i class="fas fa-dollar-sign"></i> 成交額排序({{orderdObjects('revenue').length}})</button> 
              	<button @click="order_type = 'active'" v-bind:class="{'active btn-success' : order_type == 'active'}" class="btn btn-default"><i class="far fa-smile"></i> 活躍({{orderdObjects('active').length}})</button>
              	<button @click="order_type = 'silence'" v-bind:class="{'active btn-success' : order_type == 'silence'}" class="btn btn-default"><i class="far fa-frown"></i> 沈默({{orderdObjects('silence').length}})</button>
              </div>
            </div>
            <div class="widget-wrap">
            	<h4 class="text-center">聯絡人列表 ({{ orderdObjects(this.order_type).length }})</h4>
            	<p v-if="order_type == 'revenue'"> 透過成交額排序，掌握你營收80%來源的20%重要客戶 </p>	
            	<p v-if="order_type == 'active'"> 2個月內有交易互動的公司，掌握這些公司，持續創造新訂單 </p>	
            	<p v-if="order_type == 'silence'"> 2個月以上沒有交易的公司，快去與他們保持聯繫重新建立關係！ </p>	
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th><i class="fa fa-user"></i> 名稱</th>
                    <th><i class="fa fa-building"></i> 公司</th>
                    <th><i class="fa fa-envelope"></i> Email</th>
                    <th><i class="fa fa-phone"></i> 電話</th>
                    <th>成交交易</th>
                    <th>成交率</th>
                    <th><i class="fas fa-arrow-down" v-if="order_type == 'revenue'"></i> 營收占比</th>
                    <th>
                    	<i class="fas fa-arrow-down" v-if="order_type == 'active'"></i>  
                    	<i class="fas fa-arrow-up" v-if="order_type == 'silence'"></i> 
                    	最後交易時間
                    </th>
                    <th>
                    	<i class="fas fa-arrow-down" v-if="order_type == 'new'"></i>  
                    	<i class="fas fa-arrow-up" v-if="order_type == 'old'"></i> 
                    	建立時間
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="pointer" v-for="person in orderdObjects(this.order_type)" align="left">
                    <td @click="ShowContact(person.contact_token)">{{person.name}}</td>
                    <td @click="ShowOrganization(person.organization_token)">{{person.organization_name}}</td>
                    <td>{{person.email}}</td>
                    <td>{{person.phone}}</td>
                    <td>${{person.deal_sum.toLocaleString()}}, {{person.won_deal}}筆</td>
                    <td>{{person.won_rate}}%</td>
                    <td>
                    	<span v-if="total_revenue != 0">{{Math.round(person.deal_sum*1000/total_revenue)/10}}%</span>
                    	<span v-else>0%</span>
                    </td>
                    <td>
                    	{{person.last_deal_at}}
                    </td>
                    <td>
                    	{{person.created_at}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- modal template start-->
    <div v-if="ContactModal" @keyup.esc="ContactModal = false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="ContactModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                新增聯絡人
              </div>
              <a href="#" class="btn-close" @click="ContactModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms" style="overflow:initial !important">
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-user"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="姓名*" v-model="name" name="name" v-validate="'required'">
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span v-show="errors.has('name')" class="help is-danger">不可為空值
                  </span>
                </div>
              </div>
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-envelope"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="Email" v-model="email">
                </div>
              </div>
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-phone"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="電話" v-model="phone">
                </div>
              </div>
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-building"></i></label>
                  <autocomplete :url="axios.defaults.baseURL + '/settings/auto_complete'" anchor="name" label="contact_name" param="keyword" name="autocomplete" placeholder="公司名稱" v-model="organization_name" :classes="{ input: 'form-control login-frm-input organization_name', wrapper: 'input-wrapper'}" :process="process_organization_JSON" :onSelect="handle_organization_Select" :onInput="set_organization_Value" :customHeaders=auth_token :customParams="{ type: 'organization' }">
                  </autocomplete>
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="validateBeforeSubmit">
                  建立
                </button>
                <button class="btn btn-primary" @click="ContactModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!--Page Container End Here-->
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import autocomplete from 'vue2-autocomplete-js'

export default {
  name: 'contacts',
  data() {
    return {
    	order_type: 'new',
      contacts: [],
      total_revenue: 0,
      ContactModal: false,
      name: '',
      email: '',
      phone: '',
      organization_name: '',
      auth_token: {}
    }
  },
  components: {
    autocomplete
  },
  created() {
    this.getContacts()
  },
  props: ['toggle_aside'],
  methods: {
  	orderdObjects(order_type){
  		switch(order_type){
  			case 'revenue':
	  			return _.orderBy(this.contacts, 'deal_sum','desc')
	  		case 'old':
	  			return _.orderBy(this.contacts, 'created_at','asc')
	  		case 'new':
	  			return _.orderBy(this.contacts, 'created_at','desc')
	  		case 'active':
	  			var d = new Date();
					d.setMonth(d.getMonth() - 2);
	  			var result = this.contacts.filter(a => {
	  				return a.last_deal_at && new Date(a.last_deal_at) >= d
	  			})
	  			return _.orderBy(result, 'last_deal_at','desc')
	  		case 'silence':
	  			var d = new Date();
					d.setMonth(d.getMonth() - 2);
	  			var result = this.contacts.filter(a => {
	  				return a.last_deal_at && new Date(a.last_deal_at) <= d
	  			})
	  			return _.orderBy(result, 'last_deal_at','desc')
	  		default: 
	  			return this.organizations;
  		}
  	},
    getContacts() {
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('contacts')
        .then(function(response) {
          if (response.status == 200) {
            vm.contacts = response['data']['data']['contacts']
            vm.total_revenue = response['data']['data']['total_revenue']
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    ShowContact(contact_token) {
      this.$router.push({ name: 'contact', params: { contact_token: contact_token } })
    },
    CreateContact() {
      const vm = this;
      this.axios.post('contacts', {
          contact: {
            name: this.name,
            email: this.email,
            phone: this.phone,
            organization_name: this.organization_name,
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.ShowContact(response['data']['data']['contact_token'])
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.CreateContact();
        } else {
          console.log('fails')
        }
      });
    },
    // AutoComplete callback function (Organization)
    process_organization_JSON(json) {
      return json.results.organization;
    },
    ShowOrganization(organization_token) {
      this.$router.push({ name: 'organization', params: { organization_token: organization_token } })
    },
    // if organization selected, auto assign deal name 
    handle_organization_Select(data) {
      this.organization_name = data.name
    },
    // keyup organization name
    set_organization_Value(value) {
      this.organization_name = value
    },
  }
}
</script>


// WEBPACK FOOTER //
// ContactList.vue?7799e0a1